<template>
  <div id="owner_rpts_business_reviews_rpt">
    <CardedSectionHeader
      icon="mdi-form-map"
      label="Report Filter"
      id="owner_business_reviews_report_filter"
    ></CardedSectionHeader>
    <CardedForm
      ref="owner_business_reviews_report_filter_form_ref"
      id="owner_business_reviews_report_filter_form_form"
      title="You can filter by: Start date, End date, and business"
      :is_loading="is_loading"
      @on-submit-form="filter_report"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      cmp_class="ma-0 pl-5 pr-5 pt-0 white"
      @on-clear-form="on_clear_form"
    >
      <v-row no-gutterss class="pa-0 mb-0" :key="date_input_key">
        <v-col class="pt-0 pb-0 mb-0">
          <DateField
            label="Start Date"
            v-model="form.start_date_display"
            :disabled="is_loading"
            :validation_rules="form_validations.start_date_display"
            :min="'2018-01-01'"
            :max="form.date_today"
          ></DateField>
        </v-col>
        <v-col class="pt-0 pb-0 mb-0">
          <DateField
            label="End Date"
            v-model="form.end_date_display"
            :disabled="is_loading"
            :validation_rules="form_validations.end_date_display"
            :min="form.start_date_display"
            :max="form.date_today"
          ></DateField>
        </v-col>
      </v-row>
      <v-row no-gutterss class="pa-0 mb-0">
        <v-col no-gutters class="pb-0 pt-0 mb-0">
          <SelectField
            v-model="form.business_id"
            :options="businesses"
            :small_chips="false"
            :validation_rules="form_validations.business_id"
            label="Select Business"
            icon="mdi-pen-plus"
            :disabled="is_loading"
            item_text="name"
            item_value="id"
          ></SelectField>
        </v-col>
      </v-row>
    </CardedForm>
    <CardedSectionHeader
      icon="mdi-form-map"
      label="Report Table"
      id="owner_business_reviews_report_table"
    ></CardedSectionHeader>
    <CardedTable
      :items="items"
      :headers="headers"
      :show_search="true"
      :show_description="false"
      :show_header_bar="true"
      :has_margin="false"
    >
      <template v-slot:controls>
        <div>
          <h4 class="pt-3">{{ report_message }}</h4>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </CardedTable>
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedTable from "../../../components/CardedTable";
import CardedForm from "../../../components/CardedForm";
import DateField from "../../../components/DateField";
import TextField from "../../../components/TextField";
import SelectField from "../../../components/SelectField";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "OwnerReportsBusinessReviews",
  components: {
    CardedSectionHeader,
    DateField,
    CardedTable,
    CardedForm,
    TextField,
    SelectField
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
        return ServerClient.Login.get_logged_in_user();
      },
    },
  },
  data: () => {
    return {
      errors: [],
      message: "",
      form: {
        start_date_display: Utils.get_today_date_str(),
        end_date_display: Utils.get_today_date_str(),
        business_id: -1,
      },
      form_validations: {
        start_date_display: [],
        end_date_display: [],
        business_id: [],
      },
      items: [],
      headers: [
        {
          text: "ID",
          align: "left",
          sortable: true,
          value: "id",
          filterable: true,
        },
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "business.name",
          filterable: true,
        },
        {
          text: "Date",
          align: "center",
          sortable: true,
          value: "posted_on",
          filterable: true,
        },
        {
          text: "Comment",
          align: "center",
          sortable: true,
          value: "comment",
          filterable: true,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
      report_message: "",
      date_input_key: "owner_reviews_bsns_date_inputs_key_1",
      date_input_key_truck: 1,
      businesses: []
    };
  },
  methods: {
    on_clear_form() {
      this.form.start_date_display = Utils.get_today_date_str();
      this.form.end_date_display = Utils.get_today_date_str();
      this.form.business_id = -1;
      this.date_input_key_truck = this.date_input_key_truck + 1;
      this.date_input_key =
        "owner_reviews_bsns_date_inputs_key_" + this.date_input_key_truck;
    },
    on_auto_fill() {
      this.refresh_table();
    },
    filter_report() {
      this.refresh_table();
    },
    load_my_businesses() {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_my_buinesses(
        {
          user_id: this._user.id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          var db = Utils.get_default_business();
          db.id = -1,
          db.name = "all";
          this.businesses = [db].concat(res);
          this.refresh_table();
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.$refs.owner_business_reviews_report_filter_form_ref.show_error_dialog();
        }
      );
    },
    load_items(filter_config) {
      this.$emit("on-show-loader");
      ServerClient.Reports.get_owners_reviews_businesses_report(
        {
          ...filter_config,
        },
        (res) => {
          this.items = res;

          this.process_report_message();
          this.$emit("on-hide-loader");
          var options = {
            offset: 50,
            duration: 1000,
            easing: "easeInOutCubic",
          };
          this.$vuetify.goTo("#owner_business_reviews_report_table", options);
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.errors = errors;
          this.$refs.owner_business_reviews_report_filter_form_ref.show_error_dialog();
        }
      );
    },
    refresh_table() {
      this.errors = [];
      var start_time_str = this.form.start_date_display + " 00:30:00 AM ";
      var start_time = Utils.date_str_to_php_time(start_time_str);
      var end_time_str = this.form.end_date_display + " 11:30:00 PM ";
      var end_time = Utils.date_str_to_php_time(end_time_str);
      if (start_time == end_time) {
        this.errors.push("Start time cannot be equal to end time");
        this.$refs.owner_business_reviews_report_filter_form_ref.show_error_dialog();
        return false;
      }
      if (start_time > end_time) {
        this.errors.push("Start time cannot be greater than end time");
        this.$refs.owner_business_reviews_report_filter_form_ref.show_error_dialog();
        return false;
      }

      this.load_items({
        ...this.form,
      });
    },
    process_report_message() {
      var num_str = "";
      if (this.items.length == 0) {
        num_str = " were no posted business reviews ";
      } else if (this.items.length == 1) {
        num_str = " was only (1) one posted business search ";
      } else if (this.items.length > 1) {
        num_str = " were " + this.items.length + " posted business reviews ";
      }

      var start_word = Utils.date_str_to_words(
        this.form.start_date_display,
        true,
        "of"
      );
      var end_word = Utils.date_str_to_words(
        this.form.end_date_display,
        true,
        "of"
      );
      var msg = "";
      if (this.form.start_date_display == this.form.end_date_display) {
        msg = "There " + num_str + " on the " + start_word;
      } else {
        msg =
          "There " +
          num_str +
          " between the " +
          start_word +
          " and the " +
          end_word;
      }
      this.report_message = msg;
    },
    on_view_item(item) {
      this.$router.push("/owner/businesses/list/view/" + item.business_id);
    },
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();
    this.form.user_id = this._user.id;
    //nyd
    //if is not admin please redirect this user to the login screen

    this.$emit("set-page-attributes", {
      title: "My Business reviews Report",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Reports",
          disabled: false,
          href: "/owner/reports",
        },
        {
          text: "BSNS reviews",
          disabled: true,
          href: "/owner/reports/reviews/activity",
        },
      ],
    });

    this.load_my_businesses();

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#owner_rpts_business_reviews_rpt", options);
  },
};
</script>